const AccountPage = () => import('@/pages/AccountPage.vue')
const AccountLanguage = () => import('@/pages/account/AccountLanguage.vue')
const AccountSecurity = () => import('@/pages/account/AccountSecurity.vue')
const AccountSessions = () => import('@/pages/account/AccountSessions.vue')

export default [
  {
    path: 'account',
    name: 'account',
    component: AccountPage,
    meta: {
      layout: 'default',
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'AccountLanguage',
        component: AccountLanguage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'security',
        name: 'AccountSecurity',
        component: AccountSecurity,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'sessions',
        name: 'AccountSessions',
        component: AccountSessions,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      }
    ]
  }
]
